import { FormInputText } from '@hopskipdrive/react-components';
import { useInvoiceGroups } from '@rideiq/organizers/hooks/useInvoiceGroups';

import { StyledAutocomplete } from './InvoiceGroupsFilter.styles';

export type InvoiceGroupOption = { value: string; label: string };

interface Props {
  value: InvoiceGroupOption[];
  onChange: (value: InvoiceGroupOption[]) => void;
}

const id = 'invoice-groups-filter';

export const InvoiceGroupsFilter = ({ value, onChange }: Props) => {
  const { invoiceGroups, isFetching, fetchInvoiceGroups, hasFetched } = useInvoiceGroups();

  const options: InvoiceGroupOption[] = invoiceGroups.map((group) => ({
    value: String(group.id),
    label: group.name,
  }));

  return (
    <StyledAutocomplete
      value={value}
      id={id}
      data-testid={id}
      options={options}
      isLoading={isFetching}
      multiple
      autoHighlight
      isOptionEqualToValue={(option, val) => invoiceGroups.length === 0 || option.value === val.value}
      onOpen={() => !hasFetched && fetchInvoiceGroups({ page: 1, perPage: 200 })}
      renderInput={(params) => <FormInputText {...params} variant="outlined" placeholder="Invoice Group" />}
      onChange={(_, val) => onChange(val as InvoiceGroupOption[])}
    />
  );
};
